<template>
  <div>
    <kst-output print-mode field="StockTrfNumber" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="Date" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="SourceWarehouseID" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="DestinationWarehouseID" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../StockTrfCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>